export { default } from './CheckoutPaymentMethod';
